import React from 'react';

import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  DropdownMenuGroup as ShadcnDropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { iconShape } from '../../../../../../../../../../shared/types';

const Link = ({ icon, label, onClick = undefined }) => (
  <DropdownMenuItem onClick={onClick}>
    <FontAwesomeIcon icon={icon} />
    <span>{label}</span>
  </DropdownMenuItem>
);

Link.propTypes = {
  icon: iconShape.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

const LinkGroup = ({ links }) => (
  <>
    <DropdownMenuSeparator />

    <ShadcnDropdownMenuGroup>
      {links.map(({ icon, label, onClick }) => (
        <Link icon={icon} key={label} label={label} onClick={onClick} />
      ))}
    </ShadcnDropdownMenuGroup>
  </>
);

LinkGroup.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      icon: iconShape.isRequired,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

export default LinkGroup;
